import React from 'react';
import 'antd/dist/antd.css';
import { useSelector, useDispatch } from "react-redux";

import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';

const { Sider } = Layout;
const { SubMenu } = Menu;



const Sidebar = ({ collapsed }) => {
  const dispatch = useDispatch();
  const appStore = useSelector((state) => state.authReducer);

  const SetMenuFeatures_Redux = (menuId) => {

    const arr = appStore?.menuList?.filter(a => a.MenuId === menuId)
      .map(b => ({
        MenuId: b.MenuId,
        MenuName: b.Menu_Name,
        FeatureIds: b.FeatureIds ? b.FeatureIds.split(",").map(x => x.trim()) : [],
        Features: b.Features ? b.Features.split(",").map(x => x.trim()) : [],
        ParentId: b.Parent_Id,
        MenuUrl: b.Menu_URL,
        FeatureExist: b.FeatureExist,
        AllFeatures: b.AllFeatures ? b.AllFeatures.split(",").map(x => x.trim()) : []
      }));

    dispatch({ type: "MENU_FEATURE", payload: arr });

  };

  return (
    <>
      <Sider collapsed={collapsed} width={220} style={{ backgroundColor: '#E8EEF0' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img className='rounded-full mt-1' src={process.env.REACT_APP_BASEURL + appStore?.CompanyLogo} alt="Brand Logo" style={{ height: collapsed ? '50px' : '100px', transition: 'height 0.2s' }} />
        </div>
        <Menu mode="inline" style={{ borderRight: 0, padding: 5, backgroundColor: '#E8EEF0', minHeight: '100%' }}>
          {appStore?.menuList
            .filter((item) => item.Parent_Id === null && item.Is_Displayed_In_Menu == true)
            .map((item) => (
              <SubMenu
                key={item.MenuId}
                title={
                  <span className='flex items-center gap-2'>
                    {item.IconClass && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div dangerouslySetInnerHTML={{ __html: item.IconClass }} />
                      </div>
                    )}
                    {!collapsed && (
                      <span style={{ display: 'flex', alignItems: 'center' }}>
                        {item.Menu_URL ? (
                          <Link style={{ color: 'black', fontSize: '16px' }} to={item.Menu_URL}>
                            {item.Menu_Name}
                          </Link>
                        ) : (
                          item.Menu_Name
                        )}
                      </span>
                    )}
                  </span>
                }
              >
                {appStore?.menuList
                  .filter((subItem) => subItem.Parent_Id === item.MenuId && subItem.Is_Displayed_In_Menu == true)
                  .map((subItem) => (
                    <Menu.Item key={subItem.MenuId} onClick={() => SetMenuFeatures_Redux(subItem.MenuId)}>
                      {subItem.Menu_URL ?
                        <Link to={subItem.Menu_URL}>{subItem.Menu_Name}</Link> :
                        subItem.Menu_Name}
                    </Menu.Item>
                  ))}
              </SubMenu>
            ))}
        </Menu>
      </Sider>

    </>);
};

export default Sidebar;
